import {
  type Option,
  RadioButtonGroup,
} from "@circle-react-shared/RadioButtonGroup";

interface SegmentedControlProps {
  checkedOptionClassName?: string;
  defaultChecked: string;
  hasCheckedIcon?: boolean;
  name: string;
  onChange: (value: string) => void;
  options: Option[];
  size?: "sm" | "md";
  uncheckedOptionClassName?: string;
  wrapperClassName?: string;
}

export const SegmentedControl = ({
  name,
  options,
  defaultChecked,
  onChange,
  size = "sm",
  wrapperClassName = "bg-secondary rounded-lg p-1 shadow-xs !gap-2",
  checkedOptionClassName = "bg-primary border-none",
  uncheckedOptionClassName = "bg-secondary border-none",
  hasCheckedIcon = false,
}: SegmentedControlProps) => (
  <RadioButtonGroup
    name={name}
    options={options}
    defaultChecked={defaultChecked}
    size={size}
    shouldShowInlineOptions
    onChange={onChange}
    wrapperClassName={wrapperClassName}
    checkedOptionClassName={checkedOptionClassName}
    uncheckedOptionClassName={uncheckedOptionClassName}
    hasCheckedIcon={hasCheckedIcon}
  />
);
